document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initCifras();
  initGaleriaProducto();
  initVariantes();
  initPaquetes();
  initFlotante();
  initFlotanteProducto();
  initReubicarBotonReleasit();
  initSincronizarAlAbrirReleasit();
  initTestimoniosAuto();
  initVideosAutoplayScroll();
});

function initVideosAutoplayScroll() {
  // PRUEBA: reproduce automáticamente CON SONIDO los videos marcados con
  // data-mt-video-autoplay al entrar a la pantalla, y los pausa al salir.
  // OJO: los navegadores bloquean el autoplay con sonido si el usuario no
  // ha interactuado antes con la página (clic/toque) — es muy probable que
  // esto NO suene para la mayoría de los visitantes reales, pese al intento.
  var contenedores = document.querySelectorAll('[data-mt-video-autoplay]');
  if (!contenedores.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) {
          video.playsInline = true;
          video.muted = false;
          video.play().catch(function () {
            // El navegador bloqueó el sonido: reintenta silenciado para
            // que al menos siga reproduciéndose visualmente.
            video.muted = true;
            video.play().catch(function () {});
          });
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.5 }
  );

  contenedores.forEach(function (contenedor) { observer.observe(contenedor); });
}

function initFlotanteProducto() {
  // Botón flotante de la página de producto: aparece siempre que el
  // formulario de compra original no está a la vista, ya sea porque
  // todavía no se ha llegado a él (recién se entra a la página) o porque
  // ya quedó arriba tras hacer scroll hacia abajo. Al tocarlo, lleva de
  // vuelta al botón real de Releasit (con scroll suave) en vez de abrir
  // su formulario a control remoto — así el cliente siempre lo abre desde
  // donde ya está sincronizado con el paquete elegido, evitando el
  // problema de que apareciera sin ninguna cantidad seleccionada.
  var contenedor = document.querySelector('[data-mt-flotante-producto]');
  if (!contenedor) return;
  var referencia = document.querySelector('[data-mt-form-producto]');
  if (!referencia) return;

  function actualizar(visible) {
    contenedor.classList.toggle('mt-flotante-visible', visible);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        actualizar(!entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );
  observer.observe(referencia);

  var trigger = contenedor.querySelector('[data-mt-flotante-producto-btn]');
  if (trigger) {
    trigger.addEventListener('click', function () {
      // Centra la tarjeta de 3 unidades en vez del botón de Releasit
      // directamente — así se ven las tres ofertas y el botón de compra al
      // mismo tiempo, en vez de llegar con el precio recortado arriba.
      var radioTres = document.querySelector('[data-mt-paquete-radio][data-cantidad="3"]');
      var tarjetaTres = radioTres ? radioTres.closest('[data-mt-paquete-card]') : null;
      if (tarjetaTres) {
        tarjetaTres.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        referencia.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
}

function initTestimoniosAuto() {
  var tracks = document.querySelectorAll('[data-mt-test-track]');
  if (!tracks.length) return;

  tracks.forEach(function (track) {
    // Orden fijo: el que viene definido en el editor de temas (block_order).
    var tarjetas = Array.prototype.slice.call(track.querySelectorAll('.mt-test-card'));

    if (tarjetas.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var segundos = parseFloat(track.dataset.mtVelocidad) || 4;
    var indice = 0;
    var pausado = false;
    var visible = false;

    function avanzar() {
      if (pausado || !visible) return;
      indice = (indice + 1) % tarjetas.length;
      // Mueve SOLO el carrusel (scrollLeft del track), nunca la página —
      // a diferencia de scrollIntoView, que puede arrastrar todo el scroll
      // vertical del sitio para "asegurar" que la tarjeta se vea.
      track.scrollLeft = tarjetas[indice].offsetLeft;
    }

    var intervalo = setInterval(avanzar, segundos * 1000);

    // Solo se anima mientras la sección esté realmente en pantalla —
    // si el cliente se desplazó a otra parte de la página, no hace nada.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) { visible = entry.isIntersecting; });
        },
        { threshold: 0.4 }
      );
      observer.observe(track);
    } else {
      visible = true;
    }

    function pausar() { pausado = true; }
    function reanudar() { pausado = false; }
    track.addEventListener('mouseenter', pausar);
    track.addEventListener('mouseleave', reanudar);
    track.addEventListener('touchstart', pausar, { passive: true });
    track.addEventListener('touchend', function () {
      setTimeout(reanudar, 2500);
    });

    window.addEventListener('beforeunload', function () { clearInterval(intervalo); });
  });
}

function initSincronizarAlAbrirReleasit() {
  // Releasit ahora se abre como ventana emergente (botón "PAGAR
  // CONTRAENTREGA"), así que sus radios de cantidad no existen en el DOM
  // hasta que el cliente la abre. Se sincroniza con la cantidad que el
  // cliente ya eligió arriba en las tarjetas durante una ventana corta
  // justo al abrirse (reintentando varias veces, no una sola), porque si
  // Releasit tiene configurada su propia "Preseleccionar esta oferta" a
  // veces la aplica de forma asíncrona un instante después de abrir el
  // formulario, revirtiendo una corrección hecha una sola vez. Pasada esa
  // ventana se deja de tocar por completo, para que el cliente pueda
  // cambiarla libremente dentro del formulario sin que el script se la
  // revierta (eso causaba un bucle infinito).
  var indicePorCantidad = { '1': '0', '2': '1', '3': '2' };
  var estabaAbierto = false;

  function releasitEstaAbierto() {
    return (
      !!document.getElementById('quantity_offer_0') ||
      !!document.getElementById('quantity_offer_1') ||
      !!document.getElementById('quantity_offer_2')
    );
  }

  function forzarSeleccion() {
    var cardActiva = document.querySelector('[data-mt-paquete-radio]:checked');
    if (!cardActiva) return;
    var cantidad = cardActiva.dataset.cantidad || '1';
    var indice = indicePorCantidad[cantidad];
    if (indice === undefined) return;
    var input = document.getElementById('quantity_offer_' + indice);
    if (!input || input.checked) return;
    var label = input.closest('label');
    if (label) label.click();
  }

  function sincronizarConReintentos() {
    var intentos = 0;
    var maxIntentos = 8;
    var idIntervalo = setInterval(function () {
      forzarSeleccion();
      intentos++;
      if (intentos >= maxIntentos) clearInterval(idIntervalo);
    }, 100);
  }

  var observer = new MutationObserver(function () {
    var abierto = releasitEstaAbierto();
    if (abierto && !estabaAbierto) {
      sincronizarConReintentos();
    }
    estabaAbierto = abierto;
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (releasitEstaAbierto()) {
    estabaAbierto = true;
    sincronizarConReintentos();
  }
}

function initReubicarBotonReleasit() {
  function reubicar() {
    var candidatos = document.querySelectorAll('#rsi_buy_now_button');
    var boton = null;
    candidatos.forEach(function (el) {
      if (el.closest('product-form')) boton = el;
    });
    if (!boton) return;

    var form = boton.closest('form');
    if (!form) return;
    if (form.firstElementChild === boton) return;

    boton.style.setProperty('margin-top', '24px', 'important');
    boton.style.setProperty('margin-bottom', '14px', 'important');
    form.insertBefore(boton, form.firstElementChild);
  }

  reubicar();

  var observer = new MutationObserver(function () {
    reubicar();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function initFlotante() {
  var boton = document.querySelector('[data-mt-flotante]');
  if (!boton) return;
  var hero = document.querySelector('.mt-hero');
  var cierre = document.querySelector('.mt-cierre');
  if (!hero || !cierre) return;

  var heroPasado = false;
  var cierreAlcanzado = false;

  function actualizar() {
    if (heroPasado && !cierreAlcanzado) {
      boton.classList.add('mt-flotante-visible');
    } else {
      boton.classList.remove('mt-flotante-visible');
    }
  }

  var heroObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        heroPasado = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        actualizar();
      });
    },
    { threshold: 0 }
  );
  heroObserver.observe(hero);

  var cierreObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        cierreAlcanzado = entry.isIntersecting;
        actualizar();
      });
    },
    { threshold: 0 }
  );
  cierreObserver.observe(cierre);
}

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.01, rootMargin: '0px 0px 120px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
  // Red de seguridad: si al cargar ya hay elementos visibles en pantalla
  // (o casi, por diferencias de layout), fuérzalos a mostrarse.
  window.addEventListener('load', function () {
    els.forEach(function (el) {
      if (el.classList.contains('mt-visible')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight + 300 && r.bottom > -300) {
        el.classList.add('mt-visible');
        observer.unobserve(el);
      }
    });
  });
}

function initCifras() {
  var els = document.querySelectorAll('.mt-cifra[data-fin]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = parseFloat(el.dataset.fin) || 0;
        var sufijo = el.dataset.sufijo || '';
        if (reduced) {
          el.textContent = fin + sufijo;
          observer.unobserve(el);
          return;
        }
        var inicio = 0;
        var duracion = 1400;
        var t0 = null;
        function paso(ts) {
          if (!t0) t0 = ts;
          var progreso = Math.min((ts - t0) / duracion, 1);
          var valor = Math.round(inicio + (fin - inicio) * (1 - Math.pow(1 - progreso, 3)));
          el.textContent = valor + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
        observer.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var track = galeria.querySelector('[data-mt-carrusel-track]');
  var slides = galeria.querySelectorAll('[data-mt-carrusel-slide]');
  var dots = galeria.querySelectorAll('[data-mt-carrusel-dot]');
  var prevBtn = galeria.querySelector('[data-mt-carrusel-prev]');
  var nextBtn = galeria.querySelector('[data-mt-carrusel-next]');
  if (!track || !slides.length) return;

  function indiceActual() {
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function irA(indice) {
    indice = Math.max(0, Math.min(slides.length - 1, indice));
    // scrollLeft del track, no scrollIntoView: este último puede arrastrar
    // el scroll vertical de toda la página, no solo el carrusel.
    track.scrollLeft = slides[indice].offsetLeft;
  }

  function actualizarDots() {
    var indice = indiceActual();
    dots.forEach(function (d, i) {
      d.classList.toggle('mt-dot-activo', i === indice);
      d.style.background = i === indice ? 'var(--mt-color-acento)' : 'var(--mt-color-borde)';
      d.style.width = i === indice ? '20px' : '8px';
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { irA(indiceActual() - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { irA(indiceActual() + 1); });
  dots.forEach(function (d, i) {
    d.addEventListener('click', function () { irA(i); });
  });

  var scrollTimeout;
  track.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(actualizarDots, 80);
  });

  window.addEventListener('resize', function () {
    irA(indiceActual());
  });
}

function initVariantes() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var selects = form.querySelectorAll('[data-mt-opcion]');
  if (!selects.length) return;
  var variantesJson = form.querySelector('[data-mt-variantes]');
  if (!variantesJson) return;
  var variantes;
  try {
    variantes = JSON.parse(variantesJson.textContent);
  } catch (e) {
    return;
  }
  var inputId = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioCompareEl = document.querySelector('[data-mt-precio-comparado]');
  var botonEl = document.querySelector('[data-mt-boton-comprar]');

  function seleccionActual() {
    var valores = [];
    selects.forEach(function (s) { valores.push(s.value); });
    return valores;
  }

  function actualizar() {
    var valores = seleccionActual();
    var match = variantes.find(function (v) {
      return v.options.length === valores.length && v.options.every(function (o, i) { return o === valores[i]; });
    });
    if (!match) return;
    inputId.value = match.id;
    if (precioEl && match.price_formatted) precioEl.textContent = match.price_formatted;
    if (precioCompareEl) {
      if (match.compare_at_price_formatted) {
        precioCompareEl.textContent = match.compare_at_price_formatted;
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      var span = botonEl.querySelector('span');
      if (match.available) {
        botonEl.disabled = false;
        botonEl.removeAttribute('disabled');
        if (span) span.textContent = botonEl.dataset.textoDisponible || 'Añadir al carrito';
      } else {
        botonEl.disabled = true;
        botonEl.setAttribute('disabled', 'disabled');
        if (span) span.textContent = botonEl.dataset.textoAgotado || 'Agotado';
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initPaquetes() {
  var radios = document.querySelectorAll('[data-mt-paquete-radio]');
  if (!radios.length) return;

  var tarjetaVariantInput = document.querySelector('[data-mt-tarjeta-variant]');
  var cantidadInput = document.querySelector('[data-mt-cantidad]');
  var sincronizando = false;
  var indicePorCantidad = { '1': '0', '2': '1', '3': '2' };
  var cantidadPorIndice = { '0': '1', '1': '2', '2': '3' };

  function labelReleasitParaCantidad(cantidad) {
    var indice = indicePorCantidad[cantidad];
    if (indice === undefined) return null;
    var input = document.getElementById('quantity_offer_' + indice);
    return input ? input.closest('label') : null;
  }

  function aplicarSeleccion(radio, sincronizarReleasit) {
    radios.forEach(function (r) {
      var card = r.closest('[data-mt-paquete-card]');
      if (!card) return;
      if (r === radio) {
        card.classList.add('mt-paquete-activo');
        // Estilo en línea, no solo la clase CSS: así queda garantizado
        // que se vea la tarjeta seleccionada aunque la regla de la hoja
        // de estilos no se aplique por algún motivo. Se fija el "border"
        // completo (no solo border-color) porque el navegador vacía el
        // border-style/width heredado del shorthand si solo se toca
        // border-color con !important, dejando el borde invisible.
        card.style.setProperty('border', '2px solid #c4402e', 'important');
        card.style.setProperty('box-shadow', '0 0 0 3px rgba(196, 64, 46, 0.25)', 'important');
      } else {
        card.classList.remove('mt-paquete-activo');
        // Se fija el borde neutro explícito (no solo se quita), porque
        // quitarlo dejaría la tarjeta sin ningún borde de respaldo.
        card.style.setProperty('border', '2px solid var(--mt-color-borde)', 'important');
        card.style.setProperty('box-shadow', 'none', 'important');
      }
      r.checked = r === radio;
    });

    var variantId = radio.value;
    var cantidad = radio.dataset.cantidad || '1';

    if (tarjetaVariantInput) {
      tarjetaVariantInput.value = variantId;
      tarjetaVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (cantidadInput) {
      cantidadInput.value = cantidad;
      cantidadInput.dispatchEvent(new Event('change', { bubbles: true }));
      cantidadInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (sincronizarReleasit !== false && !sincronizando) {
      var label = labelReleasitParaCantidad(cantidad);
      if (label) {
        sincronizando = true;
        label.click();
        setTimeout(function () { sincronizando = false; }, 80);
      }
    }

    document.dispatchEvent(
      new CustomEvent('mt:paquete-cambiado', {
        detail: { variantId: variantId, cantidad: cantidad, nombre: radio.dataset.nombre, precio: radio.dataset.precio },
      })
    );
  }

  radios.forEach(function (r) {
    r.addEventListener('change', function () { aplicarSeleccion(r, true); });
  });

  // Si el cliente cambia la cantidad directamente dentro del formulario de
  // Releasit (pago contraentrega), reflejar esa selección en las tarjetas.
  // Releasit es una app en React: no dispara "change" en el radio nativo,
  // solo "click" — y tarda un momento en recalcular su total. Por eso se
  // escucha "click" y se lee el resultado después de una breve espera.
  document.addEventListener('click', function (evento) {
    if (sincronizando) return;
    var label = evento.target.closest('label[for^="quantity_offer_"]');
    if (!label) return;
    // Releasit tarda un poco (y a veces más de lo normal si acaba de
    // recalcular otra selección) en confirmar su nuevo estado interno.
    // Se revisa varias veces en vez de una sola lectura a tiempo fijo.
    var intentos = 0;
    var intervalo = setInterval(function () {
      intentos++;
      var indiceSeleccionado = null;
      ['0', '1', '2'].forEach(function (i) {
        var input = document.getElementById('quantity_offer_' + i);
        if (input && input.checked) indiceSeleccionado = i;
      });
      var cantidad = cantidadPorIndice[indiceSeleccionado];
      if (cantidad) {
        var radioCoincide = null;
        radios.forEach(function (r) {
          if ((r.dataset.cantidad || '1') === cantidad) radioCoincide = r;
        });
        if (radioCoincide && !radioCoincide.checked) {
          aplicarSeleccion(radioCoincide, false);
        }
        if (radioCoincide && radioCoincide.checked) {
          clearInterval(intervalo);
          return;
        }
      }
      if (intentos >= 30) clearInterval(intervalo);
    }, 150);
  }, true); // fase de captura: Releasit detiene la propagación del clic en fase de burbuja

  var inicial = document.querySelector('[data-mt-paquete-radio]:checked') || radios[0];
  aplicarSeleccion(inicial, false);
}
